import { Guid } from "@ioip/core/lib";
import { Exception } from "@ioip/core/lib/exceptions";

export class FormNotFoundException extends Exception {

    constructor(formVersionId: Guid, innerException?: Exception) {
        super(`Form not found: ${formVersionId}`, innerException);
    }

}